import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { BaseModule } from 'lib/modules';
import { PROCESSOR_VIEW_ROLES } from 'lib/userHelpers';

// Lazy-loaded page component
const IntegrationsPage = lazy(() =>
  import(/* webpackChunkName: "integrations" */ 'pages/integrations').then(
    (m) => ({
      default: m.IntegrationsPage,
    }),
  ),
);

/**
 * Integrations Module Implementation
 */
class IntegrationsModuleClass extends BaseModule {
  id = 'INTEGRATIONS';
  name = 'Integrations';
  label = 'Integrations';
  description = 'Third-party integrations and API connections';
  version = '1.0.0';
  /**
   * Creates route objects for the Integrations module
   * @param ProtectedRoute
   * @param LazyWrapper
   * @param settings
   * @param ModuleProtectedRoute
   */
  createRoutes = (
    ProtectedRoute: any,
    LazyWrapper: any,
    settings?: any,
    ModuleProtectedRoute?: any,
  ): RouteObject[] => {
    const routes: RouteObject[] = [];
    const RouteProtector = ModuleProtectedRoute || ProtectedRoute;

    // Integrations page
    routes.push({
      path: '/integrations',
      element: (
        <RouteProtector
          component={IntegrationsPage}
          moduleId="INTEGRATIONS"
          allowedUserRoles={PROCESSOR_VIEW_ROLES}
        />
      ),
    });

    return routes;
  };
}

// Export singleton instance
export const IntegrationsModule = new IntegrationsModuleClass();
